import React, { FC, ReactElement, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cns from 'classnames';
import { Link, useHistory } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { getAllSocials, SocialDto, internalizationState, getAllStyle } from '../../../stores/reducers/sections';
import Icon from '../../Icon';
import './Footer.sass';
import routes from '../../../config/routes';
import {
  getContentFooter,
  getIsLoggedIn,
  getIsRegistrationRequired,
  setLoggedIn,
  getExhibitionNavmenuButtons,
  getNavmenuButtonsVisibility,
  getEventKey
} from '../../../stores/reducers/userData';
import { userLogout } from '../../../api';
import AlertModal from '../../Modals/AlertModal';
import localeFieldResolver from '../../../helpers/locale-field-finder';

interface FooterProps {
  className?: string;
}

const Footer: FC<FooterProps> = ({ className }): ReactElement => {
  const socials = useSelector(getAllSocials);
  let { backendURL, logo, ...footerText } = useSelector(getContentFooter);
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isRegistrationRequired = useSelector(getIsRegistrationRequired);
  const showLogin = isRegistrationRequired && !isLoggedIn;
  const {exhibitionButtonLive} = useSelector(getExhibitionNavmenuButtons);
  const liveVisible = useSelector(getNavmenuButtonsVisibility)[2];
  const showLogout = isLoggedIn;
  const dispatch = useDispatch();
  const history = useHistory();
  const styles = useSelector(getAllStyle);
  const [alertModalData, setAlertModalData] = useState<{ isOpen: boolean; close: () => void; text: string }>({
    isOpen: false,
    close: () => setAlertModalData({ ...alertModalData, isOpen: false }),
    text: '',
  });
  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    error_occured_ru: 'Возникла ошибка, повторите попытку позже',
    error_occured_en: 'An error occured, please try again later',
    registration_ru: 'Регистрация',
    registration_en: 'Registration',
    login_ru: 'Войти',
    login_en: 'Login',
    logout_ru: 'Выйти',
    logout_en: 'Logout',
  };
  const eventKey = useSelector(getEventKey);

  const localizedName = (field: string): string => localeFieldResolver(localizeData, field, activeLangState);

  const handleLogout = () => {
    userLogout(eventKey).then((response) => {
      if ([200, 204].includes(response.status)) {
        dispatch(setLoggedIn(false));
        history.push(routes.HOME);
      } else {
        setAlertModalData({ ...alertModalData, isOpen: true, text: localizedName('error_occured_ru')});
      }
    });
  };

  
  const footerHTML = localeFieldResolver(footerText, 'footer', activeLangState) as string;

  return ( styles.footer.isFooterVisible &&
    <>
      <AlertModal isOpen={alertModalData.isOpen} close={alertModalData.close} text={alertModalData.text} />
      <footer className={cns('footer bg-footer', className)}>
        <div className="container">
          <div className="footer__wrapper">
            {
              styles.footer.isLogoHidden === false &&
              <div className="footer-logo">{logo && <img src={`${backendURL}${logo}`} alt="Logo" />}</div>
            }
            <div className="footer-text">{footerHTML && ReactHtmlParser(footerHTML.replace(/color: .*?; /g, ''))}</div>
            <ul className="soc-inline">
              {socials &&
                socials.map((social: SocialDto) => (
                  <li key={social.icon} id={`${social.id}${social.icon}`}>
                    <a href={social.link} rel="noopener noreferrer" target="_blank">
                      <Icon name={social.icon} />
                    </a>
                  </li>
                ))}
            </ul>
            <nav className="footer-nav">
              <ul>
                {liveVisible &&
                  <li>
                    <Link to={routes.LIVE}>{ localeFieldResolver(exhibitionButtonLive, 'name', activeLangState) }</Link>
                  </li>
                }
                {showLogin && (
                  <>
                    {
                      styles.header.isRegistrationVisible &&
                      <li>
                        <Link to={routes.REGISTER}>{ localizedName('registration_ru') }</Link>
                      </li>
                    }
                    {
                      styles.header.isLoginVisible &&
                      <li>
                        {/* <Link to="#login">{ localizedName('login_ru') }</Link> */}
                        <a href={`https://broadcast.comdi.com/event/${eventKey}`}>{ localizedName('login_ru') }</a>
                      </li>
                    }
                  </>
                )}
                {showLogout && (
                  <li>
                    <button type="button" onClick={() => handleLogout()}>
                    { localizedName('logout_ru') }
                    </button>
                  </li>
                )}
              </ul>
            </nav>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
